import { render, staticRenderFns } from "./positionPost.vue?vue&type=template&id=87cbcf10&scoped=true&"
import script from "./positionPost.vue?vue&type=script&lang=js&"
export * from "./positionPost.vue?vue&type=script&lang=js&"
import style0 from "./positionPost.css?vue&type=style&index=0&id=87cbcf10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cbcf10",
  null
  
)

export default component.exports